const API = 'Payments';

export const API_PAYMENTS = {
  PAY: `${API}/Pay`,
  REFUND: `${API}/Refund`,
};
